<template>
  <div class="content">
    <div
      class="blocAnalysisRequestTable"
      style="display: flex; flex-direction: column;"
    >
      <div style="display: flex; flex-direction: row; min-width:max-content;">
        <div
          v-for="(analysisRequest, analysisRequestIndex) in mutableAnalysisRequests"
          :key="analysisRequestIndex"
          class="analysis-request-table-wrap"
        >
          <div
            v-for="(sample, sampleIndex) in analysisRequest.samples"
            :key="sampleIndex"
            class="woSample"
          >
            <div class="blocSample">
              <thead
                style="background-color: white; position: relative; "
              >
                <tr>
                  <th
                    class="blocSample--th"
                  >
                    <div
                      v-if="sampleIndex === 0 && analysisRequestIndex === 0"
                      class="whiteBlock column-title"
                    />
                    <v-card
                      class="column-title"
                      elevation="3"
                      :class="sampleIndex === 0 && analysisRequestIndex === 0 ? 'first' : ''"
                    >
                      <div><span class="labTypography">{{ analysisRequest.component.name }}</span></div>
                      <div v-if="isSummaryView">
                        <span class="labTypography">{{ analysisRequest.requestNumber }}</span>
                      </div>
                      <v-tooltip
                        v-else
                        bottom
                        nudgeTop="12"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            text
                            v-bind="attrs"
                            class="p-0 labTypography"
                            color="#26384B"
                            v-on="on"
                            @click="onClickOpenSummary(analysisRequest)"
                          >
                            <span class="btn--title">{{ analysisRequest.requestNumber }}</span>
                            <v-icon
                              right
                              style="text-decoration: none !important;"
                            >
                              open_in_new
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('analysisRequests.labels.details') }}</span>
                      </v-tooltip>
                    </v-card>
                  </th>
                </tr>
              </thead>

              <!-- Tableau(x) avec colonne de gauche, les titres, et à droite les éléments modifiables -->
              <div class="analysis-table__container">
                <table style="border-collapse:separate !important">
                  <tbody
                    :style="isSummaryView ? 'height: 72px;' : 'height: 87px'"
                    class="noBorders"
                  >
                    <tr
                      v-for="(sampleAttribute) in getAttributes"
                      :key="sampleAttribute"
                      class="limit-height"
                      :class="isSummaryView ? 'no-mb' : ''"
                    >
                      <td
                        v-if="sampleIndex === 0 && analysisRequestIndex === 0"
                        class="row-title firstTab"
                      >
                        <div
                          v-if="sampleAttribute === 'resultInterpretation'"
                          class="row-title--inner"
                        >
                          <div v-if="isSummaryView">
                            {{ $t(`labWorkOrderTable.labels.${sampleAttribute}`) }}
                          </div>
                        </div>
                        <div
                          v-else
                          class="row-title--inner"
                        >
                          {{ $t(`labWorkOrderTable.labels.${sampleAttribute}`) }}
                        </div>
                      </td>
                      <td
                        class="tableCell--container"
                        style="flex-shrink: 0"
                      >
                        <AnalysisRequestTableCell
                          :class="[['APPROVED', 'SUBMITTED', 'SENT'].includes(analysisRequest.labWorkOrder.status) && 'disabled-area']"
                          :analysisRequest="analysisRequest"
                          :analysisRequestId="analysisRequest.id"
                          :sampleAttribute="sampleAttribute"
                          :scope="scope"
                          :updateAnalysisRequest="debouncedUpdateAnalysisRequest"
                          :updateCouponSample="debouncedUpdateCouponSample"
                          :updateSampleFile="updateSampleFile"
                          :updateTreatment="debounceTreatment"
                          :updateGlycolType="updateGlycolType"
                          :standardFamilyList="standardFamilyList"
                          :isSummaryView="isSummaryView"
                          :depositCompositionList="depositCompositionList"
                          :analysisTypeList="analysisTypeList"
                          :updateSample="debouncedUpdateSample"
                          :sampleObj="sample"
                          :glycolTypeList="glycolTypeList"
                          :sampleId="sample.id"
                          :couponList="couponList"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div
              v-if="sampleAttributes.includes('analyses') || sampleAttributes.includes('depositComposition')"
              class="section--divider"
            />
            <!-- Etiquette de nom avec le lien souligné -->
          </div>
        </div>
      </div>
      <div v-if="sampleAttributes.includes('analyses') || sampleAttributes.includes('depositComposition')">
        <div
          class="add--analysis__list"
        >
          <span
            class="analysis-label analysis-label-lab"
          >
            {{ $t(`labWorkOrderTable.labels.analyses`) }}
          </span>
          <div class="analysis-col--container">
            <tr
              v-for="sample in samplesLists"
              :key="sample.id"
              class="analysis-col add"
            >
              <td
                class="analysis-input"
              >
                <div class="add-btn__container">
                  <v-btn
                    v-if="!isSummaryView"
                    color="secondary"
                    class="add-btn"
                    @click="onAddAnalysisType(sample)"
                  >
                    <v-icon left>
                      add
                    </v-icon>
                    {{ $t('sites.nodes.addAnalysis') }}
                  </v-btn>
                </div>
              </td>
            </tr>
          </div>
        </div>
        <div
          class="analysis-request-table-wrap"
        >
          <div
            v-if="analysis && mutableAnalysis.length"
            class="analysis-table__container"
          >
            <table>
              <tbody
                class="withBorders"
              >
                <div
                  v-for="(analyse, index) in mutableAnalysis"
                  :key="`${analyse.id}-${index}`"
                  class="row-title--wrapper"
                >
                  <tr class="td--row-title secondTab">
                    <td
                      class="row-title"
                    >
                      <div
                        class="row-title--inner d-block"
                      >
                        <div>{{ analyse.name }}</div>
                        <div class="unitOfMeasure">
                          {{ getTranslatedMeasureUnit(analyse) }}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <div class="analysis-col--container">
                    <tr
                      v-for="(value, analysisId) in analyse.value"
                      :key="`${value.analysisTypeId}-${value.sampleId}-${index}-${analysisId}`"
                      class="analysis-col"
                    >
                      <td
                        class="analysis-input"
                      >
                        <div>
                          <AnalysisTypesList
                            :isSummaryView="isSummaryView"
                            :sampleAttribute="'analyses'"
                            :analysisTypeList="getAnalysisList(value.analysisRequestId)"
                            :analysisRequestStandards="standardForEachAR[value.analysisRequestId]"
                            :updateAnalysisRequest="debouncedUpdateAnalysisRequest"
                            :conditionMatchError="conditionMatchError"
                            :value="value"
                            :isReadOnly="isReadOnly"
                          />
                        </div>
                      </td>
                    </tr>
                  </div>
                </div>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { cloneDeep, debounce, sum } from 'lodash';

import { mapGetters, mapActions } from 'vuex';
import AnalysisRequestTableCell from '@/views/laboratory/workOrder/AnalysisRequestTableCell';
import sampleForm from '@/views/laboratory/workOrder/summaryModale/SampleForm.vue';
import sampleTypes from '@/constants/sampleTypes';
import AnalysisTypesList from '@/views/laboratory/workOrder/AnalysisTypesList';
import AddAnalysisTypesForm from '@/views/laboratory/workOrder/AddAnalysisTypesForm';
import analysisTypesConstant from '@/aquassist-shared/constants/types/componentAnalysisConfiguration';
import labWorkOrderStatus from '@/constants/labWorkOrderStatus';

export default {
    components: { AnalysisRequestTableCell, AnalysisTypesList },
    props: {
        sampleAttributes: {
            type: Array,
            default: () => ([]),
        },
        scope: {
            type: String,
            default: '',
        },
        analysisTypeList: {
            type: Array,
            default: () => ([]),
        },
        compositionAnalysisTypes: {
            type: Array,
            default: () => ([]),
        },
        depositCompositionList: {
            type: Array,
            default: () => ([]),
        },
        clients: {
            type: Array,
            default: () => ([]),
        },
        sites: {
            type: Array,
            default: () => ([]),
        },
        analysisRequests: {
            type: Array,
            default: () => ([]),
        },
        standardFamilyList: {
            type: Array,
            default: () => ([]),
        },
        isSummaryView: {
            type: Boolean,
            default: false,
        },
        getNormValue: {
            type: Function,
            default: () => {},
        },
        skipFields: {
            type: Array,
            default: () => (['analyses', 'depositComposition']),
        },
        glycolTypeList: {
            type: Array,
            default: () => ([]),
        },
        analysis: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            mutableAnalysisRequests: [],
            samplesLists: [],
            data: {},
            mutableAnalysis: [],
            standardForEachAR: [],
            couponList: [],
            tableWidth: this.isSummaryView ? document.body.clientWidth - 317 : document.body.clientWidth - 271,
            loading: false,
            isReadOnly: false,
            debouncedUpdateCouponSample: debounce(this.updateCouponSample, 250),
            debounceTreatment: debounce(this.updateTreatment, 250),
            debouncedUpdateAnalysisRequest: debounce(this.updateAnalysisRequest, 250),
            debouncedUpdateSample: debounce(this.updateSample, 500),
            conditionMatchError: {},
        };
    },
    computed: {
        ...mapGetters([
            'userLang',
            'labWorkOrder',
            'teamMainLang',
            'hasPermission',
        ]),
        getAttributes() {
            return this.sampleAttributes.filter(sp => !this.skipFields.includes(sp));
        },
        computedHeights() {
            return this.mutableAnalysisRequests.reduce((accumulator, aR) => {
                const aRData = this.labWorkOrder.analysisRequests.find(aRequest => aRequest.id === aR.id);
                const newHeights = { ...accumulator }; // Create a copy of the accumulator for eslint no-param-reassign

                if (aRData) {
                    const height = this.isSummaryView ? 95 : 65;
                    const offSet = this.isSummaryView ? 1 : 2;
                    newHeights[aR.id] = height * (aRData.analysisTypes.length + offSet);
                }

                return newHeights;
            }, {});
        },
    },
    watch: {
        analysisRequests: {
            handler(val) {
                this.mutableAnalysisRequests = [...val];
                this.setIsreadOnly();
            },
            deep: true,
        },
        analysis: {
            handler(val) {
                this.mutableAnalysis = [...val.analysis];
            },
            deep: true,
            immediate: true,
        },
        labWorkOrder: {
            handler() {
                this.setIsreadOnly();
            },
            deep: true,
        },
    },
    async created() {
        this.mutableAnalysisRequests = cloneDeep(this.analysisRequests);
        if (this.scope === 'DepositSample') {
            this.setTotalIdentifiedPhases();
        }
        this.setSamples();
        this.analysisRequestStandards();
        this.setIsreadOnly();
        if (this.scope === 'CouponSample') {
            this.getCouponList();
        }
    },
    methods: {
        ...mapActions({
            reloadWorkOrderResults: 'getLabWorkOrderResults',
        }),
        getTranslatedMeasureUnit(analysis) {
            if (!analysis) return '';
            if (analysis.reportUnitOfMeasure && analysis.reportUnitOfMeasure.length) {
                return analysis.reportUnitOfMeasure;
            }
            if (analysis.measureUnit?.length) {
                return analysis.measureUnit;
            }
            return '';
        },
        async onClickOpenSummary(analysisRequest) {
            const [client] = this.clients.filter(cl => analysisRequest.client.id === cl.id);
            const preparedAnalysisRequest = cloneDeep(analysisRequest);
            this.$root.$emit('showModal', {
                title: this.$t('analysisRequests.labels.summary'),
                component: Vue.component('sampleForm', sampleForm),
                payload: {
                    mutableValue: {
                        analysisRequest: { ...preparedAnalysisRequest, client },
                        clients: [client],
                        sites: [analysisRequest.site],
                    },
                },
                clean: true,
                showConfirmButton: false,
                showNextPrevious: true,
                onConfirm: async payload => {
                    if (!payload) return;
                    if (this.hasPermission('analysisRequests.edit')) {
                        await this.$rq.updateLabWorkOrderAnalysisRequest(this.labWorkOrder.id, analysisRequest.id, payload);
                        this.showMessage();
                        await this.reloadWorkOrderResults(this.labWorkOrder.id);
                    }
                },
            });
        },
        showMessage() {
            this.$toasted.global.toast_success({
                message: this.$t('msg.poNumberUpdated'),
            });
        },
        async updateCouponSample(key, value, analysisRequest, sampleId) {
            const { samples } = analysisRequest;
            samples.forEach(sample => {
                if (sample.id === sampleId) {
                    Vue.set(sample, key, value);
                }
            });
            const payload = {
                samples: samples.map(sample => ({
                    ...sample,
                    coupon: sample.coupon && sample.coupon.id,
                    initialWeight: sample.initialWeight && sample.initialWeight * 1000,
                    finalWeight: sample.finalWeight && sample.finalWeight * 1000,
                    collectedBy: sample.collectedBy && sample.collectedBy.id,
                    pictureAfterCleaning: sample.pictureAfterCleaning && sample.pictureAfterCleaning.id,
                    pictureBeforeCleaning: sample.pictureBeforeCleaning && sample.pictureBeforeCleaning.id,
                })),
            };
            await this.$rq.updateLabWorkOrderAnalysisRequest(this.labWorkOrder.id, analysisRequest.id, payload);
        },
        async updateSample(value, field, analysisRequest, sampleId) {
            // sample additional comment are limited to 50
            if (field && field === 'comment' && value?.length > 50) {
                return;
            }

            const otherSample = analysisRequest.samples
                .filter(sample => sample.id !== sampleId)
                .map(sample => ({ id: sample.id }));
            const payload = {
                samples: [
                    {
                        id: sampleId,
                        [field]: value,
                    },
                    ...otherSample,
                ],
            };
            try {
                await this.$rq.updateAnalysisRequest(analysisRequest.id, payload);
            } catch (error) {
                // reload only if somethig went wrong with the save to make sure we have current backend value
                await this.reloadWorkOrderResults(this.labWorkOrder.id);
            }
        },
        updateSampleFile(analysisRequest, sampleId, key, value) {
            const formData = new FormData();
            formData.append(key, value);
            return this.$rq.uploadSamplePicture(analysisRequest.id, sampleId, formData);
        },
        async updateAnalysisRequest(key, value, analysisRequest, analysisType, isSampleValue) {
            const payload = {
                type: analysisRequest.type,
            };
            if (analysisType) {
                if (analysisRequest.sample) {
                    payload.samples = [
                        {
                            id: analysisRequest.sample.id,
                            analysisType: analysisType.analysisTypeId || analysisType.id,
                            value,
                            symbole: analysisType.symbole,
                        },
                    ];
                } else {
                    const samplesList = value.id ? [analysisRequest.samples.find(sample => sample.id === value.id)] : analysisRequest.samples;
                    payload.samples = samplesList.map(sample => ({
                        id: sample.id,
                        analysisType: analysisType.analysisTypeId || analysisType.id,
                        value: value.id ? value.value : value,
                        symbole: analysisType.symbole,
                    }));
                }
            } else if (isSampleValue) {
                if (key === 'depositPicture') {
                    const formData = new FormData();
                    formData.append('depositPicture', value);
                    const { data: picture } = await this.$rq.uploadSamplePicture(analysisRequest.id, analysisRequest.samples[0].id, formData);
                    payload.samples = analysisRequest.samples.map(sample => ({
                        id: sample.id,
                        [key]: picture.id,
                    }));
                } else {
                    // value.id is for WO with multiple samples.
                    payload.samples = value.id ? [analysisRequest.samples.find(sample => sample.id === value.id)].map(sample => ({
                        id: sample.id,
                        [key]: value.value,
                    })) : analysisRequest.samples.map(sample => ({
                        id: sample.id,
                        [key]: value,
                    }));
                }
            } else {
                payload[key] = value;
            }
            try {
                const { data } = await this.$rq.updateLabWorkOrderAnalysisRequest(this.labWorkOrder.id, analysisRequest.id, payload);
                const updatedAnalysisRequests = data.length ? data.filter(aR => aR.type === this.scope) : [];
                if (key === 'applicableNorms') {
                    // reload standards
                    this.analysisRequestStandards(value);
                    if ([sampleTypes.COUPON, sampleTypes.LEGIONELLOSIS, sampleTypes.LEGIONELLA_CULTRURE].includes(analysisRequest.type)) {
                        this.$emit('reloadAnalysis', updatedAnalysisRequests);
                    } else {
                        this.$emit('reloadAnalysis');
                    }
                    return;
                }
                if (analysisType && analysisType.analysisTypeId) {
                    this.conditionMatchError = {
                        ...this.conditionMatchError,
                        [analysisType.analysisTypeId + analysisType.sampleId]: updatedAnalysisRequests[0].conditionMatchError,
                    };
                }
                if (key === 'organicMaterial') {
                    this.setTotalIdentifiedPhases(true, analysisRequest, updatedAnalysisRequests);
                }
            } catch (error) {
                // reload only if somethig went wrong with the save to make sure we have current backend value
                await this.reloadWorkOrderResults(this.labWorkOrder.id);
            }
        },
        async updateTreatment(id, treatmentData) {
            this.loading = true;
            const payload = { treatment: treatmentData };
            await this.$rq.updateAnalysisRequest(id, payload);
            this.loading = false;
        },
        async updateGlycolType(id, type) {
            this.loading = true;
            const payload = { glycolType: type };
            await this.$rq.updateAnalysisRequest(id, payload);
            this.loading = false;
        },
        setSamples() {
            this.samplesLists = this.mutableAnalysisRequests.flatMap(aR => aR.samples);
        },
        getHeight(analysisRequest) {
            return this.computedHeights[analysisRequest.id] || 0;
        },
        onAddAnalysisType(sample) {
            const initialAnalysisTypes = [...this.analysisRequests.find(aR => aR.id === sample.analysisRequestId)?.analysisTypes];
            const analysisList = this.getAnalysisList(sample.analysisRequestId);
            this.$root.$emit('showModal', {
                title: this.$t('analyses.addAnalysisType'),
                component: Vue.component('AddAnalysisTypesForm', AddAnalysisTypesForm),
                payload: {
                    analysisTypeList: analysisList.map(analysisType => ({
                        ...analysisType,
                        name: analysisType.name[this.userLang] || analysisType.name[this.teamMainLang],
                        analysisTypeId: analysisType.id,
                    })),
                    initialAnalysisTypes,
                },
                onConfirm: async (requestPayload = []) => {
                    await this.$rq.updateAnalysisRequest(sample.analysisRequestId, {
                        analysisTypes: requestPayload.map(item => item.key),
                    });
                    await this.reloadWorkOrderResults(this.labWorkOrder.id);
                    this.$emit('reloadAnalysis');
                },
            });
        },
        analysisRequestStandards(newApplicableNorm) {
            this.analysisRequests.forEach(analysisRequest => {
                if (!this.standardForEachAR[analysisRequest.id]) this.standardForEachAR[analysisRequest.id] = [];
                if (analysisRequest.applicableNorms && this.standardFamilyList.length > 0) {
                    const applicableNorm = newApplicableNorm || analysisRequest?.applicableNorms?.id || analysisRequest?.applicableNorms;
                    const [standardFamily] = this.standardFamilyList.filter(family => applicableNorm === family.id);
                    const { standards: allStandards } = standardFamily;
                    // For now we just looking for Simple and Legionella stnadards

                    let standardCat = analysisTypesConstant.SIMPLE_ANALYSIS_TYPE;
                    if (this.scope === sampleTypes.LEGIONELLOSIS || this.scope === sampleTypes.LEGIONELLA_CULTRURE) {
                        standardCat = analysisTypesConstant.TYPE_LEGIONELLA;
                    }
                    // if standard family has standard
                    if (allStandards?.length) {
                        // filter the standards to be sure standards are base on scope
                        const standards = allStandards.filter(st => st.analysisType?.type === standardCat);
                        analysisRequest.analysisTypes.forEach(analysisType => {
                            let foundStandard;
                            const standardsByAnalysis = standards.filter(s => analysisType.id === s?.analysisType?.id);
                            foundStandard = standardsByAnalysis.find(st => st?.networkType?.id === analysisRequest.networkType.id
                                && st?.componentType?.id === analysisRequest.component.type.id);
                            if (foundStandard) {
                                this.standardForEachAR[analysisRequest.id].push(foundStandard);
                                return;
                            }
                            // standard with network = any and component and analysis type match
                            foundStandard = standardsByAnalysis.find(st => !st?.networkType
                                && st?.componentType?.id === analysisRequest.component.type.id);
                            if (foundStandard) {
                                this.standardForEachAR[analysisRequest.id].push(foundStandard);
                                return;
                            }
                            // standard with componentType = any and network and analysis type match
                            foundStandard = standardsByAnalysis.find(st => !st?.componentType
                                && st?.networkType?.id === analysisRequest.networkType.id);
                            if (foundStandard) {
                                this.standardForEachAR[analysisRequest.id].push(foundStandard);
                                return;
                            }
                            // standard with network = any and componenttype = any  and analysis type match
                            foundStandard = standardsByAnalysis.find(st => !st?.componentType && !st?.networkType);
                            if (foundStandard) {
                                this.standardForEachAR[analysisRequest.id].push(foundStandard);
                            }
                        });
                    } else if (this.standardForEachAR[analysisRequest.id] && this.standardForEachAR[analysisRequest.id].length) {
                        this.standardForEachAR[analysisRequest.id] = [];
                    }
                }
            });
        },
        getAnalysisList(analysisRequestId) {
            const aRType = this.analysisRequests.find(ar => ar.id === analysisRequestId)?.type;
            return aRType !== sampleTypes.DEPOSIT ? this.analysisTypeList : this.depositCompositionList;
        },
        async getCouponList() {
            const { data } = await this.$rq.getCoupons({ pagination: false });
            this.couponList = data.coupons.map(coupon => ({
                ...coupon,
                name: coupon.name[this.userLang] || coupon.name[this.teamMainLang],
            }));
        },
        setIsreadOnly() {
            this.isReadOnly = this.labWorkOrder?.status !== labWorkOrderStatus.IN_PROGRESS;
        },
        setTotalIdentifiedPhases(isUpdate = false, analysisRequest, newAnalysisRequests) {
            if (isUpdate) {
                this.mutableAnalysisRequests = newAnalysisRequests.map(aR => {
                    if (aR.id === analysisRequest.id) {
                        // eslint-disable-next-line no-param-reassign
                        aR = {
                            ...aR,
                            samples: aR.samples.map(sample => ({
                                ...sample,
                                ...this.getTotalIdentifiedPhases(sample),
                            })),
                        };
                    }
                    return aR;
                });
            } else {
                this.mutableAnalysisRequests = this.mutableAnalysisRequests.map(aR => {
                    // eslint-disable-next-line no-param-reassign
                    aR = {
                        ...aR,
                        samples: aR.samples.map(sample => ({ ...sample, ...this.getTotalIdentifiedPhases(sample) })),
                    };
                    return aR;
                });
            }
        },
        getTotalIdentifiedPhases(sample) {
            // Organic Material (%) + Mineral Phases (%)
            const organicMaterial = sample.organicMaterial || 0;
            const mutableDepositCompositions = [...sample?.measures].filter(item => item.type === 'CompositionAnalysisType');
            const mineralPhases = parseFloat(sum(mutableDepositCompositions.map(({ value }) => (value ? parseFloat(value) : 0)))).toFixed(1);
            const result = parseFloat(organicMaterial) + parseFloat(mineralPhases);
            return { mineralPhases, totalIdentifiedPhases: Number.isNaN(result) ? '' : (result.toFixed(1) || 0) };
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/utils/_variables.scss";
@import '@/assets/styles/components/_analysisGrid.scss';

.labTypography {
    font-weight: 400 !important;
    letter-spacing: normal;
    ::v-deep .v-btn__content {
        font-weight: 400 !important;
        .btn--title {
            font-weight: 400;
            text-decoration: underline;
        }
    }
}
.tableCell--container {
    height: 40px !important;
}
::v-deep .v-text-field fieldset, ::v-deep .v-text-field .v-input__control {
    border-color: #C4C4C4 !important;
}
.section--divider {
    border-top: 1px solid #C4C4C4;
    width: 100%;
    margin-top: 40px;
}
.first {
  margin-left: 190px;// width of the first column (labels at the right)
}

.whiteBlock {
  width: 189px;
  height: 80px;
  background-color: white;
  position: absolute;
  top: 0;
  z-index: 3;
}
.unitOfMeasure{
    font-weight: normal;
    font-size: 13px;
}

</style>
